import { createRef, RefObject, useMemo } from 'react';

/**
 * Builds a memoized array of refs that is reinitialized when the count changes.
 *
 * @param count The length of the ref array.
 */
export function useRefList<TRefType>(count: number): RefObject<TRefType>[] {
    return useMemo<RefObject<TRefType>[]>(
        () => [...new Array(count)].map(() => createRef<TRefType>()),
        [count]
    );
}
